import React, { useEffect, useRef } from 'react'
import diceSliderImage from '../../images/dice-slider.png'
import { BET_RESULT } from 'constants/index'

const DiceFairnessModalResult = ({ roundBetHistory, result, number, rollOver, betResult }) => {
  const round = roundBetHistory || {}
  const winning = Number.isFinite(Number(result)) ? Number(result) : Number(round.winningNumber)
  const hasResult = Number.isFinite(winning)
  const diceResult = hasResult ? winning : null
  const sliderNumber = Number(number ?? round.number ?? 50)
  const isRollOver = String(rollOver ?? round.rollOver ?? true) === 'true'
  const outcome = betResult ?? round.result
  const isWin = outcome
    ? outcome === BET_RESULT.WON
    : hasResult && (isRollOver ? winning > sliderNumber : winning < sliderNumber)
  const diceImgRef = useRef(null)
  const diceSliderRef = useRef(null)

  useEffect(() => {
    // eslint-disable-next-line
    const $slider = $(diceSliderRef.current)
    $slider.rangeslider({ polyfill: false })
    return () => $slider.rangeslider('destroy')
  }, [])

  useEffect(() => {
    if (!diceSliderRef.current) return
    // small delay so the handle visibly slides from 50 to the number
    const timer = setTimeout(() => {
      // eslint-disable-next-line
      $(diceSliderRef.current).val(sliderNumber).change()
    }, 50)
    return () => clearTimeout(timer)
  }, [sliderNumber])

  useEffect(() => {
    const diceImg = diceImgRef.current
      if (diceImg && hasResult) {
      diceImg.style.left = `calc(${diceResult}% - 50px)`
      diceImg.style.display = 'block'
    }
  }, [diceResult])
  return (

    <>
      <ul className='p-0 m-0 user-detail'>
        <li className='provably-text d-flex justify-content-between flex-column flex-sm-row'>
          <p className='mb-0'>
            Dice
          </p>
        </li>
      </ul>
      <div className='border-section'>
        <div className={`col-12 col-lg game-dice-col d-flex flex-column-reverse justify-content-between pb-0 gap-2 dice-container fairness-dice ${isRollOver ? 'roll-over' : 'roll-under'}`}>
          <div className='slider-section justify-content-md-between'>
            <div className='w-100  mb-5'>
              <div className='slider-box mt-lg-0'>
                <div
                  className='slider-scale'
                  style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    color: 'white'
                  }}
                >
                  <span>0</span>
                  <span>25</span>
                  <span>50</span>
                  <span>75</span>
                  <span>100</span>
                </div>
                <div className='inner-box' style={{ pointerEvents: 'none' }}>
                  <input
                    type='range'
                    id='diceSliderFairness'
                    ref={diceSliderRef}
                    min='0'
                    max='100'
                    step='0.01'
                    defaultValue={sliderNumber}
                    readOnly
                  />
                  <div style={{ position: 'relative', margin: '0px 24px' }}>
                    <div ref={diceImgRef} className='dice-img-box show-result' style={{ left: `calc(${diceResult}% - 50px)` }}>
                      {
                        diceResult
                          ? (
                            <img
                              src={diceSliderImage}
                              className='img-fluid dice-img'
                              alt='Dice Img'
                            />
                            )
                          : <></>
                      }
                      {/* eslint-disable-next-line */}
                      <span className={`dice-status ${isWin ? 'status-win' : 'status-lose'}`}>
                      {hasResult ? diceResult.toFixed(2) : ''}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default DiceFairnessModalResult
